export class CreditRating {
  public score: number;
  public category: string;
}